import { render, staticRenderFns } from "./TimeslotItemForm.vue?vue&type=template&id=113caa32"
import script from "./TimeslotItemForm.vue?vue&type=script&lang=js"
export * from "./TimeslotItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports